import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storage: window.localStorage,  // Ensure session is properly stored
    autoRefreshToken: true,        // Enable automatic token refresh
    persistSession: true,          // Persist session across reloads
    detectSessionInUrl: true,      // Detect session from the URL (for OAuth)
  },
  realtime: {
    reconnectAfterMs: () => 1000,  // Prevents real-time disconnect issues
  },
});

export default supabase;  // ✅ Export only ONE instance globally
